<template>
  <div class="qr-thanks-wrapper">
    <v-container class="py-10 fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card elevation="10" rounded="xl" class="pa-6">
            <div class="text-h5 font-weight-bold mb-2">
              Teşekkürler
            </div>
            <div class="text-body-1 mb-6">
              Kaydınız başarıyla alındı.
              <span v-if="refno" class="font-weight-medium">Referans: {{ refno }}</span>
            </div>

            <v-card-actions class="pa-0 d-flex flex-wrap" style="gap: 12px;">
              <v-btn
                color="primary"
                class="text-capitalize"
                large
                @click="goNew"
              >
                Yeni Şikayet - Öneri Formu
              </v-btn>
              <v-btn
                color="secondary"
                class="text-capitalize"
                large
                @click="tryClose"
              >
                Kapat
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { computed, getCurrentInstance } from "@vue/composition-api";

export default {
  setup() {
    const vm = getCurrentInstance()?.proxy;
    const refno = computed(() => {
      const q = vm?.$route?.query || {};
      const v = q.ref == null ? "" : String(q.ref || "");
      return v && v !== "-" ? v : "";
    });
    const channel = computed(() => {
      const q = vm?.$route?.query || {};
      const v = q.channel == null ? "public" : String(q.channel || "public");
      return v === "personnel" ? "personnel" : "public";
    });

    const goNew = async () => {
      const name = channel.value === "personnel" ? "qr-complaint-personnel" : "qr-complaint-public";
      try {
        await vm?.$router?.replace({ name });
      } catch (e) {}
    };

    const tryClose = () => {
      // Mobil tarayıcılarda çoğunlukla engellenir; yine de deneyelim.
      try {
        window.close();
      } catch (e) {}
      // Kapanmadıysa ekranda kalması sorun değil; kullanıcı geri dönebilir.
    };

    return {
      refno,
      goNew,
      tryClose,
    };
  },
};
</script>

<style scoped>
.qr-thanks-wrapper {
  min-height: 100vh;
  background: #f6f6f8;
}

.theme--dark .qr-thanks-wrapper {
  background: #28243d;
}
</style>

